import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=6a37e0bf&scoped=true&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"
import style0 from "./loading.vue?vue&type=style&index=0&id=6a37e0bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a37e0bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a37e0bf')) {
      api.createRecord('6a37e0bf', component.options)
    } else {
      api.reload('6a37e0bf', component.options)
    }
    module.hot.accept("./loading.vue?vue&type=template&id=6a37e0bf&scoped=true&", function () {
      api.rerender('6a37e0bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/loading.vue"
export default component.exports